import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import site from 'pro/config/site';

type IProps = {
    // props
}

const BlackFridayCheckInTips: React.FC<IProps> = (props) => {

    return(
        <div className={styles['tips-wrap']}>
            <p>
                From November 10th to November 29th, users who visit the website and participate in the check-in event will be rewarded points in the following manner:
            </p>

            <ul>
                <li>100 points on the 1st day,</li>
                <li>100 points on the 2nd day,</li>
                <li>200 points on the 3rd day,</li>
                <li>200 points on the 4th day,</li>
                <li>420 points on the 5th day.</li>
            </ul>

            <p>
                Users who complete the entire 5-day check-in will earn a total of <b>1020 points</b> . These points can be used to <b>deduct $10.20 USD</b> from their order total or be used to participate in the Bonus Item promotion to <b>receive a {site.brand} hoodie</b> . Participants are limited to checking in once per day.
            </p>
        </div>
    );
};

export default BlackFridayCheckInTips